import { inject, Injectable, untracked } from "@angular/core";
import {
	COMMONS_IMAGES_DATA_SOURCE,
	CommonsImagesDataSource,
	ImageSourceId,
} from "@jack-sparrow-libraries/angular-business-commons";
import { AgatheYouCareService } from "@services/agathe-you-care.service";
import { AgatheYouCareAssets } from "@core/constantes/agathe-you-care.constant";

@Injectable()
export class ImagesSourceService implements CommonsImagesDataSource {
	private readonly agatheYouCareService = inject(AgatheYouCareService);

	getImage(id: ImageSourceId): string {
		switch (id) {
			case ImageSourceId.CREATION_PATIENT_CV_STEP_1:
				return "/static-assets/imgs/creation-patient/creation-patient-cv-step-1.svg";
			case ImageSourceId.CREATION_PATIENT_CV_STEP_2:
				return "/static-assets/imgs/creation-patient/creation-patient-cv-step-2.svg";
			case ImageSourceId.CREATION_PATIENT_CV_STEP_3:
				return "/static-assets/imgs/creation-patient/creation-patient-cv-step-3.svg";
			case ImageSourceId.CREATION_PATIENT_APP_CV_STEP_1:
				return "/static-assets/imgs/creation-patient/creation-patient-ay-app-cv-step-1.svg";
			case ImageSourceId.CREATION_PATIENT_APP_CV_STEP_2:
				return "/static-assets/imgs/creation-patient/creation-patient-ay-app-cv-step-2.svg";
			case ImageSourceId.CREATION_PATIENT_APP_CV_STEP_3:
				return "/static-assets/imgs/creation-patient/creation-patient-ay-app-cv-step-3.svg";
			case ImageSourceId.CREATION_PATIENT_APP_CV_STEP_4:
				return "/static-assets/imgs/creation-patient/creation-patient-ay-app-cv-step-4.svg";
			case ImageSourceId.ICON_APP:
				return "agathe-you";
		}
	}

	// `untracked` évite seulement le suivi du signal : l'image reste figée parce que `commons-loader`
	// (angular-business-commons) est en OnPush et appelle cette méthode depuis son template.
	getLoadingImage(): string {
		return untracked(this.agatheYouCareService.$isCare)
			? AgatheYouCareAssets.LOADER
			: AgatheYouCareAssets.LOADING_IMAGE_AY;
	}
}

export const provideCommonsImagesDataSource = () => ({
	provide: COMMONS_IMAGES_DATA_SOURCE,
	useClass: ImagesSourceService,
});
